var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[(_vm.menuFunctions.VIEW_DASHBOARD)?_c('dashboard'):_c('dont-have-permission-page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }